import { type EligibilityCriteriaResultResponseType } from '@shared/generated';
import { type CriteriaSummary } from '@shared/types/eligibility';

export const isEligibilityCriteriaResultResponseType = (
  res: object
): res is EligibilityCriteriaResultResponseType => {
  if (res === null || res === undefined) {
    return false;
  }
  if (
    'evaluation_id' in res &&
    'criteria' in res &&
    'status' in res &&
    'answer' in res
  ) {
    return true;
  } else {
    return false;
  }
};

export const isCriteriaSummaryType = (
  criteriaSummary: object | null | undefined
): criteriaSummary is CriteriaSummary => {
  if (criteriaSummary === null || criteriaSummary === undefined) {
    return false;
  }
  if (
    'criteria' in criteriaSummary &&
    'answer' in criteriaSummary &&
    'descriptions' in criteriaSummary &&
    'programStatuses' in criteriaSummary
  ) {
    return true;
  } else {
    return false;
  }
};
